import React from 'react';
import styles from './QuantityControls.module.scss';;

export const Inc = props => (
  <svg viewBox="0 0 18 18" width="18px" height="18px" {...props}>
    <path className={styles.inc} d="M9,0.999954 C13.418244,0.999954 16.999956,4.581666 16.999956,8.999964 C16.999956,13.418244 13.418244,16.999974 9,16.999974 C4.581666,16.999974 0.999954,13.418244 0.999954,8.999964 C0.999954,4.581666 4.581666,0.999954 9,0.999954 Z" />
    <path className={styles.fg} d="M7.999885,7.999975 L7.999885,3.999972 L9.99995,3.999972 L9.99995,7.999975 L13.999936,7.999975 L13.999936,9.99995 L9.99995,9.99995 L9.99995,13.999949 L7.999885,13.999949 L7.999885,9.99995 L3.999894,9.99995 L3.999894,7.999975 L7.999885,7.999975 Z" />
  </svg>
);

export const Dec = props => (
  <svg viewBox="0 0 18 18" width="18px" height="18px" {...props}>
    <path className={styles.dec} d="M8.999946,0.999972 C13.41828,0.999972 16.999992,4.581684 16.999992,8.999982 C16.999992,13.418262 13.41828,16.999992 8.999946,16.999992 C4.581684,16.999992 0.999972,13.418262 0.999972,8.999982 C0.999972,4.581684 4.581684,0.999972 8.999946,0.999972 Z" />
    <polygon className={styles.fg} points="3.99992 9.999905 3.99992 7.999935 13.999884 7.999935 13.999884 9.999905" />
  </svg>
);
